import { render, staticRenderFns } from "./help_pdf.vue?vue&type=template&id=a0997738&scoped=true&"
import script from "./help_pdf.vue?vue&type=script&lang=js&"
export * from "./help_pdf.vue?vue&type=script&lang=js&"
import style0 from "./help_pdf.vue?vue&type=style&index=0&id=a0997738&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0997738",
  null
  
)

export default component.exports